import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Offre } from '../_models/offre';
import { ContactService } from '../_services/contact.service';
import { OffreService } from '../_services/offre.service';
import { MatDialog } from '@angular/material/dialog';
import { NousRejoindreSpontaneComponent } from '../nous-rejoindre-spontane/nous-rejoindre-spontane.component';
import { MetadataServiceService } from '../_services/metadata-service.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-nous-rejoindre-detail',
  templateUrl: './nous-rejoindre-detail.component.html',
  styleUrls: ['./nous-rejoindre-detail.component.scss']
})
export class NousRejoindreDetailComponent implements OnInit {

  infoBandeau = {
    'image' : './../../assets/bandeau-etablissement.png',
    'titre' : '',
    'breadcrumb' : 'ACCUEIL > Nous rejoindre'
  }

  submitted = false;
  postulationForm : any = [];
  offre : Offre = new Offre();
  fileToUploadCV: File | any = null;
  fileToUploadLettre: File | any = null;

  constructor(private dialog: MatDialog, private offreService: OffreService, private route: ActivatedRoute, private formBuilder: FormBuilder, private contactService : ContactService
    , private metadataService: MetadataServiceService, readonly snackBar: MatSnackBar) {
    this.offreService.getOneOffreBySlug(this.route.snapshot.params.slug).subscribe(
      (offre) => {
        this.offre = offre;
        this.infoBandeau.titre = this.offre.titre;

        this.metadataService.updateMetadata({
          title: 'Le Patis Fraux - ' + this.infoBandeau.titre,
          description: 'Offre d\'emploi : ' + this.offre.titre
        });
      }
    );

    this.postulationForm = this.formBuilder.group({
      cv: new FormControl('', [
        Validators.required
      ]),
      lettre: new FormControl(''),
      slugOffre: new FormControl(''),
      nom: new FormControl('', [
        Validators.required
      ]),
      prenom: new FormControl('', [
        Validators.required
      ]),
      email: new FormControl('', [
        Validators.required
      ]),
      telephone: new FormControl('', [
        Validators.required
      ]),
      check: new FormControl('', [
        Validators.required
      ])
    });

  }

  get f() { return this.postulationForm.controls; }

  handleFileInputCV(event: any) {
    this.fileToUploadCV = event.target.files.item(0);
  }
  handleFileInputLettre(event: any) {
    this.fileToUploadLettre = event.target.files.item(0);
  }

  private async readFile(file: File): Promise<string | ArrayBuffer> {
    return new Promise<string | ArrayBuffer>((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = e => {
        const result = reader.result;
        if (result !== null) {
          resolve(result as string | ArrayBuffer);
        } else {
          reject(null);
        }
      };

      reader.onerror = e => {
        console.error(`FileReader failed on file ${file.name}.`);
        return reject(null);
      };

      if (!file) {
        console.error('No file to read.');
        return reject(null);
      }

      reader.readAsDataURL(file);
    });
  }

  onSubmit(): void{
    this.submitted = true;

    if (this.postulationForm.invalid) {
      return;
    }
    this.postulationForm.controls['slugOffre'].setValue(this.offre.slug);

    if(this.fileToUploadCV){
      if(this.fileToUploadLettre){
        this.readFile(this.fileToUploadCV).then(fileContents => {
          this.readFile(this.fileToUploadLettre).then(fileContentsLettre => {
            this.contactService.postuler(fileContents, this.fileToUploadCV.name, fileContentsLettre, this.fileToUploadLettre.name, this.postulationForm.value, this.offre.titre).subscribe(data => {
              this.postulationForm.reset();  // Reset the form
              this.submitted = false;
              this.snackBar.open('Merci pour votre candidature, elle a bien été reçue par le service des Ressources Humaines. Nous allons étudier vos expériences et qualifications dans les plus brefs délais.', '', {
                duration: 5000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['snackbar-success']
              });
            })
          })
        })
      } else {
        this.readFile(this.fileToUploadCV).then(fileContents => {
          this.contactService.postulerWithoutLettre(fileContents, this.fileToUploadCV.name, this.postulationForm.value, this.offre.titre).subscribe(data => {
            this.postulationForm.reset();  // Reset the form
            this.submitted = false;
            this.snackBar.open('Merci pour votre candidature, elle a bien été reçue par le service des Ressources Humaines. Nous allons étudier vos expériences et qualifications dans les plus brefs délais.', '', {
                duration: 5000,
                horizontalPosition: 'right',
                verticalPosition: 'top',
                panelClass: ['snackbar-success']
              });
          })
        })
      }
      } else {

      }
  }

  ngOnInit(): void {
  }

  openCandidatureSpotanee() {
    this.dialog.open(NousRejoindreSpontaneComponent, {
      width: '50%',
      panelClass: "modal-spontanee"
    });
  }
}
